export const url = process.env.REACT_APP_URL
export function headers() {
  return {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
  }
}
